import React, { useState } from "react";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import Pager from "../../Components/Global/Pager";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import SleevesSearchContainer from "~/Components/Containers/SleevesSearchContainer";
import SleeveResult from "~/Components/SleeveResult";

const SearchPage = ({ location }) => {
  let history = useHistory();
  const queryStringParams = queryString.parse(location.search);
  const { page: startPage = 1, find: searchTerm } = queryStringParams;
  const [page, setPage] = useState(parseInt(startPage, 10));

  const updatePageCallBack = (toPage) => {
    history.push(`?find=${searchTerm}&page=${toPage}`);
    setPage(toPage);
  };

  return (
    <div className="page-search">
      <Helmet>
        <title>Sleevery | Search | Dream Chimney</title>
      </Helmet>
      <Row>
        <Col xs={12}>
          <h1 class="page-header">Search</h1>
        </Col>
        <Col xs={12}>
          <SleevesSearchContainer
            find={searchTerm}
            page={page}
            render={({ result }) => {
              const { sleeves, perPage, total } = result;
              const pages = Math.ceil(total / perPage);

              if (sleeves.length === 0) return null;
              return (
                <Row>
                  <Col xs={12}>
                    <ul class="results">
                      {sleeves.map((sleeve) => (
                        <li key={sleeve.id}>
                          <SleeveResult key={`search-${page}-${searchTerm}`} sleeve={sleeve} />
                        </li>
                      ))}
                    </ul>
                  </Col>

                  <Col xs={12}>
                    <div style={{ padding: "20px 0" }}>
                      <Pager className="pagination-footer" page={page} pages={pages} updatePage={updatePageCallBack} />
                    </div>
                  </Col>
                </Row>
              );
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SearchPage;
